"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var notificationHelper_1 = require("../../../../../../../shared/helpers/notificationHelper");
var CardEditorContainer_1 = require("../../../../../../../shared/components/containers/CardEditorContainer");
var CardRowButtonSet_1 = require("../../../../../../../shared/components/editors/CardRowButtonSet");
var CardRowTextEditor_1 = require("../../../../../../../shared/components/editors/CardRowTextEditor");
var PartnerTrackerEditor = /** @class */ (function (_super) {
    __extends(PartnerTrackerEditor, _super);
    function PartnerTrackerEditor(props) {
        return _super.call(this, props) || this;
    }
    PartnerTrackerEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    title: _item.tracker_title
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Трекеры партнера", "Редактировать трекер"]);
                });
            }
        }
        else {
            this.setState({
                title: ""
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Трекеры партнера", "Создать трекер"]);
            });
        }
        this.doReSetRules();
    };
    PartnerTrackerEditor.prototype.doReSetRules = function () {
        this.setState({
            title_rules: { isError: false }
        });
    };
    PartnerTrackerEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.title) || (this.state.title.length === 0)) {
            this.setState({ title_rules: { isError: true, errorMessage: "Поле [название] не заполнено!" } });
            return false;
        }
        return true;
    };
    PartnerTrackerEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                tracker_title: this.state.title
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Трекер партнера изменен!");
            });
        }
    };
    PartnerTrackerEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                usr_partner_id: this.props.rootRecord.key,
                tracker_title: this.state.title
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Трекер партнера добавлен!");
            });
        }
    };
    PartnerTrackerEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    PartnerTrackerEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Новый трекер партнера";
        }
        else {
            return "Изменить трекер партнера";
        }
    };
    PartnerTrackerEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 280 },
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Название:", placeholder: "Введите название" }, value: this.state.title, onValueChanged: function (newVal) {
                    _this.setState({
                        title: newVal,
                        title_rules: { isError: false }
                    });
                }, required: true, rules: this.state.title_rules }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return PartnerTrackerEditor;
}(React.Component));
exports.default = PartnerTrackerEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_partners_list/ui/component/tracker/PartnerTrackerEditor.tsx
// module id = 2435
// module chunks = 0